import { render, staticRenderFns } from "./PurposeStep.vue?vue&type=template&id=127f0860&"
import script from "./PurposeStep.vue?vue&type=script&lang=js&"
export * from "./PurposeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports